
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_46143","data-name":"Group 46143","xmlns":"http://www.w3.org/2000/svg","width":"114.713","height":"102.305"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15699","data-name":"Rectangle 15699","width":"114.713","height":"102.305","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_46142","data-name":"Group 46142","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_38731","data-name":"Path 38731","d":"M98.706 102.305h-82.7A16.024 16.024 0 010 86.3V63.353q0-.633.05-1.262a3.7 3.7 0 01-.049-.6 3.586 3.586 0 01.386-1.624q.138-.616.324-1.219L14.01 15.43A15.92 15.92 0 0129.3 4.135h11.516a3.6 3.6 0 010 7.2H29.3a8.755 8.755 0 00-8.411 6.212L8.477 57.891h16.406A15.917 15.917 0 0139.2 66.74l1.411 2.823a8.759 8.759 0 007.877 4.869h17.739a8.761 8.761 0 007.879-4.871l1.411-2.821a15.915 15.915 0 0114.315-8.849h16.4l-12.4-40.343a8.763 8.763 0 00-8.414-6.213H73.9a3.6 3.6 0 110-7.2h11.518a15.928 15.928 0 0115.295 11.3L114 58.653c.124.4.231.8.322 1.208a3.641 3.641 0 01.338 2.237q.049.624.049 1.253V86.3a16.025 16.025 0 01-16 16M7.2 65.09V86.3a8.815 8.815 0 008.8 8.806h82.7a8.817 8.817 0 008.806-8.806V65.09H89.833a8.758 8.758 0 00-7.876 4.868l-1.411 2.822a15.917 15.917 0 01-14.319 8.851H48.483a15.916 15.916 0 01-14.316-8.849l-1.412-2.824a8.756 8.756 0 00-7.873-4.868zm50.156-12.4a3.583 3.583 0 01-2.506-1.02l-.041-.041-16.538-16.538A3.6 3.6 0 0143.361 30l10.4 10.4V3.6a3.6 3.6 0 017.2 0v36.794L71.35 30a3.6 3.6 0 015.092 5.092L59.906 51.626l-.041.041a3.583 3.583 0 01-2.506 1.015","fill":"#727994"}})])])
          )
        }
      }
    